import angular from "angular";
import "ngstorage";

import env from "./env";
import security from "./security";
import auth from "./auth";
import events from "./events";
import teams from "./teams";
import companies from "./companies";
import signon from "./signon";
import profile from "./profile";
import common from "./common";
import messagingv2 from "./messagingv2";
import iterable from "./iterable";
import social from "./social";
import jobs from "./jobs";
import tracking from "./tracking";
import scroll from "./scroll";
import orders from "./orders";
import validation from "./validation";
import branchio from "./branchio";
import analytics from "./analytics";

export default angular.module("app.services", []).service({
  env,
  security,
  auth,
  events,
  teams,
  social,
  iterable,
  signon,
  jobs,
  companies,
  profile,
  common,
  orders,
  messagingv2,
  tracking,
  scroll,
  validation,
  branchio,
  analytics,
});



// WEBPACK FOOTER //
// ./client/app/services/services.js